/* RIOF Farbe des Monats – Parade (13.10.2026)
   Watzmanns fahren langsam von rechts nach links durchs Bild. Wischen bzw. Ziehen schiebt die Parade
   (mit Schwung), Darüberfahren hält sie an, Tippen öffnet das Möbel im Konfigurator: auf derselben
   Seite über wkSetzen, sonst über den Link. Bei jedem Laden neu gemischt, zwei Sitzbänke nie
   nebeneinander, abwechselnd hoch und tief. Für die Endlosschleife wird die Reihe einmal kopiert. */
(function () {
  if (window.riofFdmParade) return;
  window.riofFdmParade = true;
  const TEMPO = 38;                       // px pro Sekunde
  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const bank = (a) => a.dataset.form === 'sitzbank';

  function mischen(spur) {
    const alle = Array.from(spur.children);
    const n = alle.length;
    let reihe = alle;
    for (let v = 0; v < 50; v++) {
      reihe = alle.slice().sort(() => Math.random() - 0.5);
      if (!reihe.some((a, i) => bank(a) && bank(reihe[(i + 1) % n]))) break;
    }
    const kopie = reihe.map((a) => { const k = a.cloneNode(true); k.setAttribute('aria-hidden', 'true'); return k; });
    spur.replaceChildren(...reihe, ...kopie);
    // gerade Anzahl: das Muster hoch/tief läuft auch über die Naht der Schleife weiter
    Array.from(spur.children).forEach((a, i) => a.style.setProperty('--hoch', (i % n) % 2));
  }

  function oeffnen(a) {
    const k = document.querySelector('[data-wk-root]');
    if (!k || !k.wkSetzen) { window.location.href = a.href; return; }
    const farbe = new URL(a.href, location.href).searchParams.get('farbe');
    const o = { form: a.dataset.form, farbe };
    if (bank(a)) { o.links = a.dataset.links; o.rechts = a.dataset.rechts; } else o.charakter = a.dataset.charakter;
    k.wkSetzen(o);
    k.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function starte(spur) {
    if (spur.dataset.fdmBereit) return;
    spur.dataset.fdmBereit = '1';
    mischen(spur);
    const box = spur.parentElement;
    const karussell = spur.closest('riof-hero-karussell');
    let pos = 0, auto = 0, schwung = 0, zuletzt = 0, sichtbar = false, laeuft = false, ueber = false;
    let ziehen = null, gezogen = false;

    const aktiv = () => sichtbar && !document.hidden && (!karussell || karussell.classList.contains('riof-hk--fdm-aktiv'));

    function bild(t) {
      const dt = zuletzt ? Math.min(0.05, (t - zuletzt) / 1000) : 0;
      zuletzt = t;
      if (!ziehen) {
        const soll = ueber || ruhig || !aktiv() ? 0 : TEMPO;
        auto += (soll - auto) * Math.min(1, dt * 3);
        pos -= (auto + schwung) * dt;
        schwung *= Math.exp(-dt * 2.5);
        if (Math.abs(schwung) < 1) schwung = 0;
      }
      const h = spur.scrollWidth / 2;
      if (h > 0) pos = ((pos % h) - h) % h;     // immer im Bereich (−h, 0]
      spur.style.transform = `translate3d(${pos}px, 0, 0)`;
      if (sichtbar || ziehen || schwung) requestAnimationFrame(bild);
      else { laeuft = false; zuletzt = 0; }
    }
    const los = () => { if (!laeuft) { laeuft = true; requestAnimationFrame(bild); } };

    new IntersectionObserver((e) => { sichtbar = e[0].isIntersecting; if (sichtbar) los(); }).observe(box);

    // im Home-Karussell nicht weiterblättern, solange jemand mit der Parade spielt
    const halt = () => karussell && karussell.stoppe && karussell.stoppe();
    const weiter = () => karussell && karussell.starte && karussell.starte();
    box.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { ueber = true; halt(); } });
    box.addEventListener('pointerleave', () => { ueber = false; weiter(); });
    box.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      ziehen = { x: e.clientX, y: e.clientY, pos, t: performance.now(), v: 0, waagrecht: null };
      gezogen = false;
      halt();
      los();
    });
    window.addEventListener('pointermove', (e) => {
      if (!ziehen) return;
      const dx = e.clientX - ziehen.x, dy = e.clientY - ziehen.y;
      if (ziehen.waagrecht === null && Math.hypot(dx, dy) > 6) ziehen.waagrecht = Math.abs(dx) > Math.abs(dy);
      if (ziehen.waagrecht === false) { ziehen = null; return; }   // senkrecht: die Seite scrollt
      if (!ziehen.waagrecht) return;
      gezogen = true;
      const jetzt = performance.now(), neu = ziehen.pos + dx;
      const dt = Math.max(1, jetzt - ziehen.t);
      ziehen.v = 0.7 * ziehen.v + 0.3 * ((pos - neu) / dt) * 1000;   // px/s nach links
      ziehen.t = jetzt;
      pos = neu;
      ziehen.pos = neu; ziehen.x = e.clientX; ziehen.y = e.clientY;
      auto = 0;
    }, { passive: true });
    const loslassen = () => {
      if (!ziehen) return;
      if (gezogen) schwung = Math.max(-2500, Math.min(2500, ziehen.v));
      ziehen = null;
    };
    window.addEventListener('pointerup', loslassen);
    window.addEventListener('pointercancel', loslassen);

    // Wischen in der Parade soll das Home-Karussell nicht weiterblättern
    ['touchstart', 'touchend'].forEach((typ) => box.addEventListener(typ, (e) => e.stopPropagation(), { passive: true }));
    box.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-form]');
      e.stopPropagation();
      e.preventDefault();
      if (!a || gezogen) return;
      oeffnen(a);
    });
    box.addEventListener('dragstart', (e) => e.preventDefault());
  }

  const alle = () => document.querySelectorAll('[data-fdm-parade]').forEach(starte);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
